<template>
  <main class="soil-test-single">
    <MetaHead/>
    <TestDetails/>
    <TestResult v-if="$store.getters['tests/soil/extentions'].length"/>
    <InterpretationChart 
      v-if="$store.getters['tests/soil/extentions'].length && $store.getters['tests/soil/form'].methodId"
    />
  </main>
</template>

<script>
import MetaHead from '@/components/tests/soil/MetaHead'
import TestDetails from '@/components/tests/soil/TestDetails'
import TestResult from '@/components/tests/soil/TestResult'
import InterpretationChart from '@/components/tests/soil/InterpretationChart'
import { TestAPI } from '@/api';
import { mapGetters } from 'vuex';

export default {
  components: {
    TestDetails,
    TestResult,
    MetaHead,
    InterpretationChart,
  },
  methods: {
    selectDefaultLab() {
      const lab = this.labs.find(n => n.name == 'Default');

      if(!lab) return;

      this.form.methodId = lab.id;
      this.$store.dispatch('tests/soil/onLabSelect', lab.id);
    },
    async init(route) {
      const loadLists = async () => {
        await Promise.all([
          this.$store.dispatch('tests/soil/loadTextures'),
          this.$store.dispatch('tests/soil/loadLabs'),
        ])
      }

      if(/new/.test(route.name)) {
        this.$store.commit('tests/soil/clearForm');
        this.$store.commit('tests/soil/setCreateMode', true);
        this.$store.dispatch('tests/soil/initDefaultData');
        loadLists().then(this.selectDefaultLab);
      } else {
        this.$store.commit('tests/soil/setCreateMode', false);
        this.$store.dispatch('tests/soil/getSingle', route.params.test);
        loadLists();
      }
    }
  },
  created() {
    this.init(this.$route);
  },
  watch: {
    $route(to) {
      this.init(to)
    }
  },
  computed: {
    ...mapGetters({
      labs: 'tests/soil/labs',
      form: 'tests/soil/form',
    })
  }
}
</script>

<style lang="scss" scoped>

.soil-test-single {
  .test-details {

  }
  .crop-info {
    margin-top: 8px;
  }
  .test-result {
    margin-top: 8px;
  }
}

</style>
